import {
  WALLET_SETTING_SUCCESS,
  WALLET_SETTING_FAILED,
  WALLET_SETTING_INVALID_REQ,
  LOADING_WALLET_SETTING,
  RESET_WALLET_SETTING
} from "../types";

const initialState = {
  isLoading: false,
  success: false,
  failed: false,
  invalidRequest: false,
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_WALLET_SETTING:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        invalidRequest: false,
        data: {}
      };

    case WALLET_SETTING_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        invalidRequest: false,
        data: action.payload
      };
    case WALLET_SETTING_INVALID_REQ:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        failed: false,
        data: action.payload
      };

    case WALLET_SETTING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        invalidRequest: false,
        failed: false,
        data: action.payload
      };

    case RESET_WALLET_SETTING:
      return (state = initialState);

    default:
      return state;
  }
};
